import * as XLSX from "xlsx";

export function useExcelExport() {
  const exportToExcel = (data, filename, sheetName = "Sheet1") => {
    if (!data || data.length === 0) {
      console.warn("No data to export");
      return;
    }

    try {
      const workbook = XLSX.utils.book_new();

      const worksheet = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

      const colWidths = [];
      const range = XLSX.utils.decode_range(worksheet["!ref"]);

      for (let C = range.s.c; C <= range.e.c; ++C) {
        let maxWidth = 10;
        for (let R = range.s.r; R <= range.e.r; ++R) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
          const cell = worksheet[cellAddress];
          if (cell && cell.v) {
            const cellValue = String(cell.v);
            maxWidth = Math.max(maxWidth, cellValue.length);
          }
        }
        colWidths.push({ wch: Math.min(maxWidth, 50) });
      }

      worksheet["!cols"] = colWidths;

      const timestamp = new Date()
        .toISOString()
        .slice(0, 19)
        .replace(/:/g, "-");
      const finalFilename = `${filename}_${timestamp}.xlsx`;

      XLSX.writeFile(workbook, finalFilename);

      console.log(`Excel file exported: ${finalFilename}`);
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      throw error;
    }
  };

  const formatDataForExport = (data, columns) => {
    if (!data || !columns) return [];

    return data.map((row) => {
      const formattedRow = {};
      columns.forEach((column) => {
        if (column.key && row.hasOwnProperty.call(column.key)) {
          let value = row[column.key];

          if (
            column.type === "currency" &&
            value !== null &&
            value !== undefined
          ) {
            value = `$${parseFloat(value).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`;
          } else if (column.type === "date" && value) {
            value = new Date(value).toLocaleDateString("en-US");
          } else if (
            column.type === "number" &&
            value !== null &&
            value !== undefined
          ) {
            value = parseFloat(value);
          }

          formattedRow[column.label || column.key] = value;
        }
      });
      return formattedRow;
    });
  };

  const transformRFIArray = (originalArray) => {
    return originalArray.map((item) => {
      const today = new Date();
      const sortedHistory =
        item.statusHistory?.sort(
          (a, b) => new Date(a.modifiedAt) - new Date(b.modifiedAt)
        ) || [];

      const submittedEntry = sortedHistory.find(
        (entry) => entry.value === "Submitted and waiting"
      );

      const lastComment = item.commentsHistory[0];

      const dateSent =
        item.date_initiated ||
        submittedEntry?.modifiedAt ||
        (sortedHistory.length > 0 ? sortedHistory[0].modifiedAt : null);

      const currentStatus =
        item.statusHistory?.length > 0
          ? item.statusHistory.sort(
              (a, b) => new Date(b.modifiedAt) - new Date(a.modifiedAt)
            )[0].value
          : item.status;

      let aging = null;
      if (dateSent && currentStatus !== "Completed") {
        const dateSentObj = new Date(dateSent);
        const timeDiff = today - dateSentObj;
        aging = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      }
      return {
        "RFI # - Description": item.ID + "-" + item.question_request,
        "Date sent": dateSent,
        // "Date Response Required": "",
        Aging: aging + " days" || "",
        "Sent to": item.directed_to || "",
        Answer: item.comments,
        "Date Answered": lastComment?.modifiedAt || "",
        "Open/Closed": item.stat === "Completed" ? "Closed" : "Open",
        Notes: item.additional_comments,
      };
    });
  };

  return {
    exportToExcel,
    formatDataForExport,
    transformRFIArray,
  };
}
